module.exports = __webpack_public_path__ + "static/img/user.522d95b1.svg";